import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import postal from 'postal';
import MetricNumber from './metric-number';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;

  ${props => (props.theme.isXLarge ? `
    flex-grow: 2;
    align-items: center;
    &:before {
      order: -1;
      content: "";
      display: block;
      height: 0;
      width: 80px;
      margin: 0;
      margin-left: 50px;
      margin-right: calc(50px + 24px);
      border: 1px solid ${props.theme.secondaryColor};
    }
  ` : `
    margin: 24px 0;
  `)};
`;

const Text = styled.span`
  font: ${props => props.theme.fontWeightMedium} 18px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};
  ${props => (props.theme.isMobileOrTablet ? `
    order: -1;
    width: 100%;
    margin-bottom: 24px;
  ` : `
    &:not(:first-child):before {
      content: "\u2022";
      font-size: 15px;
      line-height: 100%;
      font-weight: ${props.theme.fontWeightBold};
      margin: 0 16px;
    }
  `)};
`;

const formatDate = d => moment(d, 'YYYY-MM-DD', 'Australia/Sydney').format('MMMM YYYY');

const interests = {
  channel: 'micro-profile.commands',
  topic: 'follow-status',
};

const unsub = () => postal.unsubscribe(interests);

export default function Stats({
  profileId, since, wiresCount, viewsCount, followersCount,
}) {
  const [liveFollowersCount, setLiveFollowersCount] = React.useState(followersCount);
  const numerics = [
    { count: liveFollowersCount, name: 'follower' },
    { count: wiresCount, name: 'wire' },
    { count: viewsCount, name: 'view' },
  ];
  const sinceText = since ? `Contributor Since ${formatDate(since)}` : '';

  const sub = React.useCallback(n => postal.subscribe({
    ...interests,
    callback: d => (d.id === profileId && setLiveFollowersCount(n + (d.following ? 1 : -1))),
  }), [profileId]);

  React.useEffect(() => {
    sub(liveFollowersCount);
    return () => unsub();
  }, [liveFollowersCount, sub]);

  return (
    <Container>
      {numerics.map(d => <MetricNumber {...d} key={d.name} />)}
      <Text>{sinceText}</Text>
    </Container>
  );
}

Stats.propTypes = {
  profileId: PropTypes.number.isRequired,
  since: PropTypes.string,
  followersCount: PropTypes.number,
  viewsCount: PropTypes.number,
  wiresCount: PropTypes.number,
};

Stats.defaultProps = {
  since: null,
  followersCount: 0,
  viewsCount: 0,
  wiresCount: 0,
};
